var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_268_338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.045V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_268_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5106 0.00585938L13.7604 6.58555L21.021 7.64092L15.7658 12.7659L17.0061 19.9974L10.5106 16.5834L4.01508 19.9974L5.25534 12.7659L0 7.64092L7.26069 6.58555L10.5106 0.00585938Z",
    fill: "#FF7E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5106 0.00585938L13.7604 6.58555L21.021 7.64092L15.7658 12.7659L17.0061 19.9974L10.5106 16.5834L4.01508 19.9974L5.25534 12.7659L0 7.64092L7.26069 6.58555L10.5106 0.00585938Z",
    fill: "#FF7E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5106 0.00585938L13.7604 6.58555L21.021 7.64092L15.7658 12.7659L17.0061 19.9974L10.5106 16.5834L4.01508 19.9974L5.25534 12.7659L0 7.64092L7.26069 6.58555L10.5106 0.00585938Z",
    fill: "#FF7E33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.348254a55ea1df9911d0de496959301b.svg";
export { ForwardRef as ReactComponent };